import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Banknote, Receipt, Trophy, LogOut, Shield, Bell, LifeBuoy, Wallet, FileText, Wrench, BellRing, Activity } from "lucide-react";
import ErrorBoundary from "@/components/ErrorBoundary";

const navItems = [
  { to: "/admin/dashboard", icon: LayoutDashboard, label: "Overview" },
  { to: "/admin/users", icon: Users, label: "Traders" },
  { to: "/admin/wallet", icon: Wallet, label: "Wallet" },
  { to: "/admin/loans", icon: Banknote, label: "Loans" },
  { to: "/admin/transactions", icon: Receipt, label: "Transactions" },
  { to: "/admin/documents", icon: FileText, label: "Documents" },
  { to: "/admin/support", icon: LifeBuoy, label: "Support" },
  { to: "/admin/reminders", icon: BellRing, label: "Reminders" },
  { to: "/admin/referrals", icon: Trophy, label: "Referrals" },
  { to: "/admin/scheduler", icon: Bell, label: "Notifications" },
  { to: "/admin/cron", icon: Activity, label: "Cron Health" },
  { to: "/admin/tools", icon: Wrench, label: "Tools" },
];

export default function AdminShell() {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem("kobolog_admin_token");
    nav("/admin/login");
  };

  return (
    <div className="min-h-[100dvh] bg-kudi-cream flex">
      {/* Sidebar */}
      <aside className="w-64 bg-kudi-ink text-white flex flex-col shrink-0 hidden md:flex">
        <div className="p-5 border-b border-white/10">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-kudi-terracotta flex items-center justify-center">
              <Shield className="w-4 h-4" />
            </div>
            <div>
              <div className="font-heading font-bold">Kobolog</div>
              <div className="text-xs text-white/50">Admin Console</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((n) => (
            <NavLink
              key={n.to} to={n.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition ${
                  isActive ? "bg-kudi-terracotta text-white" : "text-white/70 hover:bg-white/5 hover:text-white"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
            >
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} className="m-3 flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-white/70 hover:bg-rose-500/10 hover:text-rose-300 transition" data-testid="admin-logout">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden bg-kudi-ink text-white p-3 flex items-center gap-3 sticky top-0 z-30">
        <Shield className="w-5 h-5" />
        <span className="font-heading font-bold">Kobolog Admin</span>
        <div className="flex-1 flex justify-end gap-1 overflow-x-auto no-scrollbar">
          {navItems.map((n) => (
            <NavLink
              key={n.to} to={n.to}
              className={({ isActive }) =>
                `shrink-0 px-3 py-1.5 rounded-lg text-xs font-medium transition ${
                  isActive ? "bg-kudi-terracotta text-white" : "text-white/60 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </div>
        <button onClick={logout} className="shrink-0 text-white/60"><LogOut className="w-4 h-4" /></button>
      </div>

      <main className="flex-1 overflow-auto">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
